import { useEffect } from "react";

export const BRAND = "Zubee Factory";

/**
 * Updates the document title with the provided text
 * @param title Optional title text to append to the brand name
 */
export default function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    if (title && title.length > 0) {
      document.title = `${BRAND} | ${title}`;
    } else {
      document.title = BRAND;
    }
  }, [title]);

  return null; // Return null to satisfy ReactNode requirement
}
